import { EUiStates } from "@constants/enum";
import { showNotification } from "@easydev/Notification";
import { AxiosPromise } from "axios";
import { useEffect, useState } from "react";
import TObjectFilledWithStrings from "types/Shared/objectFilledWithStrings";

type THook = (uuid: string) => AxiosPromise<any>;

interface IUseDeleteItem {
  isModalOpen: boolean;
  isDeleting: boolean;
  handleDelete: (APIDelete: THook) => void;
  handleIsModalOpen: () => void;
}

const useDeleteItem = (
  basicData: TObjectFilledWithStrings | undefined
): IUseDeleteItem => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState("");

  const handleDelete = (APIDelete: THook) => {
    setIsDeleting(true);

    APIDelete(itemToDelete)
      .then(() => {
        setIsModalOpen(!isModalOpen);
        setIsDeleting(false);
        showNotification(
          "Success",
          "The item was successfully deleted.",
          EUiStates.SUCCESS
        );
      })
      .catch((error) => {
        showNotification(
          "Error",
          `An error occurred while deleting. | ${error}`,
          EUiStates.DANGER
        );
      });
  };

  const handleIsModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    if (basicData?.uuid) {
      setItemToDelete(basicData?.uuid);
      handleIsModalOpen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicData]);

  return {
    isModalOpen,
    isDeleting,
    handleDelete,
    handleIsModalOpen,
  };
};

export default useDeleteItem;
